import { Flex } from 'components';
import { FieldLabel, SwitchButton } from 'components/_form';
import { ApproversTable } from 'components/ApproversTable/ApproversTable';
import { IOption } from 'components/_form/Select/Select';
import { IExecutionProgressTracking } from 'types/executionProgressTrackings';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { IApprovalSchemeFormValues } from 'types/approver';

interface Props {
  executionProgressTrackings: IExecutionProgressTracking[];
  userFunctionsList: IOption[];
  selectedTrackingId?: number | null;
  /** Task types: show „Wymagaj zatwierdzenia”. Audit form modal: hide (toggle is outside). */
  showRequiresApproval?: boolean;
}

export const ApprovalSchemeApproversSection: React.FC<Props> = ({
  executionProgressTrackings,
  userFunctionsList,
  selectedTrackingId,
  showRequiresApproval = false
}) => {
  const { t } = useTranslation();
  const { control } = useFormContext<IApprovalSchemeFormValues>();

  return (
    <Flex gap="8px" flexDirection={['column', 'row']}>
      <Flex flexDirection="column" gap="12px">
        {showRequiresApproval && (
          <Flex flexDirection="column" gap="4px">
            <FieldLabel>
              {t('administrationTasksView.requireApproval')}
            </FieldLabel>
            <Controller
              control={control}
              name="requires_approval"
              render={({ field: { onChange, value } }) => (
                <SwitchButton value={!!value} onChange={onChange} />
              )}
            />
          </Flex>
        )}

        <Flex flexDirection="column" gap="4px">
          <FieldLabel>{t('administrationTasksView.inThisOrder')}</FieldLabel>
          <Controller
            control={control}
            name="in_this_order"
            render={({ field: { onChange, value } }) => (
              <SwitchButton value={!!value} onChange={onChange} />
            )}
          />
        </Flex>
      </Flex>

      {selectedTrackingId ? (
        <ApproversTable
          executionProgressTrackings={executionProgressTrackings}
          userFunctionsList={userFunctionsList}
        />
      ) : (
        <FieldLabel>
          {t('administrationTasksView.selectStatusTrackingFirst')}
        </FieldLabel>
      )}
    </Flex>
  );
};
